import { render, staticRenderFns } from "./CreateCas.vue?vue&type=template&id=edeeb952&scoped=true"
import script from "./CreateCas.vue?vue&type=script&lang=js"
export * from "./CreateCas.vue?vue&type=script&lang=js"
import style0 from "./CreateCas.vue?vue&type=style&index=0&id=edeeb952&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edeeb952",
  null
  
)

export default component.exports